import { runtimeEnv } from '@/lib/runtimeEnv';

/**
 * Environment variable utilities for proper boolean handling.
 * Runtime settings are always strings, so we need to parse them correctly.
 */

export function getBooleanEnvVar(key: string, defaultValue: boolean = false): boolean {
  const value = runtimeEnv[key];
  
  // If not set, return default
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }
  
  // Parse string to boolean
  const stringValue = String(value).toLowerCase().trim();
  
  // Consider these as true
  if (stringValue === 'true' || stringValue === '1' || stringValue === 'yes' || stringValue === 'on') {
    return true;
  }
  
  // Consider these as false
  if (stringValue === 'false' || stringValue === '0' || stringValue === 'no' || stringValue === 'off') {
    return false;
  }
  
  // Default to false for any other values
  return defaultValue;
}

export function getStringEnvVar(key: string, defaultValue: string = ''): string {
  const value = runtimeEnv[key];
  return value !== undefined && value !== null ? String(value) : defaultValue;
}

/**
 * Unity-specific configuration - hardcoded for reliability
 */
export const UnityEnvVars = {
  get forceReload(): boolean {
    return true; // Always force reload to ensure Unity cleanup
  },
  
  get unsafeImmediate(): boolean {
    return true; // Always use immediate unload for safety
  },
  
  get debug(): boolean {
    return false; // Keep console clean
  },
  
  get developmentMode(): boolean {
    // Use simplified Unity cleanup for all environments
    return true;
  }
} as const;
